// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart canvas,
.performinAgentChart {
  position: relative;
  /* height: 350px; */
  /* height: 90%; */
  width: 90%;
  min-height: 400px;
  max-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/home/agent-performance-status/agent-performance-status.component.scss"],"names":[],"mappings":"AAEA;;EAEE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAAF","sourcesContent":["@import '../../../assets/theme/css/dashboard.css';\n\n.chart canvas,\n.performinAgentChart {\n  position: relative;\n  /* height: 350px; */\n  /* height: 90%; */\n  width: 90%;\n  min-height: 400px;\n  max-height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
